import { useEffect, useState } from "react";
import * as React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import queryString from "querystring";

import { Button } from "antd";
import ButtonGroup from "antd/es/button/button-group";

import SignupNickname from "../../../components/channel/signup/SignUpNickname";

const SignUpSuccess = () => {
	const history = useHistory();
	const cUser = useSelector((state) => state.auth.channelUser);
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const queryJson = queryString.parse(
		history.location.search?.replace("?", "")
	);
	// const channelId = queryJson?.id;
	const signupType = queryJson?.type;

	const [step, setStep] = useState(0);

	useEffect(() => {
		// if (reduxChannel?.influencer_id) {
		//     if (channelId) {
		//         if (reduxChannel?.user_id !== 8 || reduxChannel?.user_id !== 1) {
		//             if (!(channelId === 'squidtv' || channelId === 'admin')) {
		//                 history.replace(`/together/channel?id=${channelId}`);
		//             }
		//         }
		//     }
		// }
		// if (cUser?.id) {
		//     history.goBack();
		// }
	}, [reduxChannel, history, cUser]);

	return (
		<div className={`channel-wrap channel-home channel-delay`}>
			<div className={`home-body home-each`}>
				<div className={`max-width-apply`}>
					{!step ? (
						<SignupNickname setStep={setStep} />
					) : (
						<div className={`home-recommend-horizontal sign-up-div`}>
							<div className={`recommend-title`}>
								<img
									src={`/assets/images/login/signup-check.png`}
									alt={`회원가입 성공 아이콘`}
									className={`signup-success-img`}
								/>
								<p className={`title`}>
									회원가입이{"\n"}
									완료 되었습니다!
								</p>
							</div>

							<div className={`signup-body`}>
								<p className={`signup-success-font`}>
									환영합니다!{"\n"}
									{reduxChannel?.nickname}에서{"\n"}
									소통을 시작해보세요!
								</p>
							</div>

							<div className={`signup-footer`} style={{ padding: 0 }}>
								<ButtonGroup>
									<Button
										className={`black-button`}
										style={{ width: "100%" }}
										onClick={() => {
											const backPage = sessionStorage.getItem("backPage");
											if (signupType) {
												if (backPage) {
													history.replace(backPage);
													sessionStorage.removeItem("backPage");
												} else {
													history.replace(
														`/together/channel/login?id=` +
															reduxChannel?.influencer_id
													);
												}
											} else {
												history.replace(
													`/together/channel/login?id=` +
														reduxChannel?.influencer_id
												);
											}
										}}
									>
										{signupType ? "가입완료" : "로그인 하러가기"}
									</Button>
								</ButtonGroup>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};
export default SignUpSuccess;
